import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import { Layers, Clock, TrendingUp, CheckCircle, Lock } from 'lucide-react';

const StakingPage = () => {
    const [activeTab, setActiveTab] = useState('active');

    const stakingPools = [
        { id: 1, coin: 'USDT', name: 'Tether', apr: '12.5%', duration: '30 Days', minStake: '100 USDT', status: 'active' },
        { id: 2, coin: 'BTC', name: 'Bitcoin', apr: '5.2%', duration: '90 Days', minStake: '0.01 BTC', status: 'active' },
        { id: 3, coin: 'ETH', name: 'Ethereum', apr: '6.8%', duration: '60 Days', minStake: '0.1 ETH', status: 'active' },
        { id: 4, coin: 'BNB', name: 'Binance Coin', apr: '8.5%', duration: 'Locked', minStake: '1 BNB', status: 'full' },
    ];

    return (
        <div className="bg-[#0b0e11] min-h-screen text-white font-sans selection:bg-purple-500/30">
            <Navbar />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {/* Hero */}
                <div className="bg-gradient-to-r from-purple-900 to-indigo-900 rounded-3xl p-8 sm:p-12 mb-12 relative overflow-hidden">
                    <div className="absolute top-0 right-0 p-12 opacity-10">
                        <Layers size={300} />
                    </div>
                    <div className="relative z-10 max-w-2xl">
                        <h1 className="text-4xl font-bold mb-4">Albatech Staking</h1>
                        <p className="text-xl text-purple-200 mb-8">Earn passive income with up to 20% APR. Secure, flexible, and profitable.</p>
                        <button className="bg-white text-purple-900 px-8 py-3 rounded-xl font-bold hover:bg-gray-100 transition shadow-lg">Start Earning</button>
                    </div>
                </div>

                {/* Filter */}
                <div className="flex gap-4 mb-8">
                    <button
                        onClick={() => setActiveTab('active')}
                        className={`px-6 py-2 rounded-full font-bold transition ${activeTab === 'active' ? 'bg-purple-600 text-white' : 'bg-[#181a20] text-gray-400 hover:text-white'}`}
                    >
                        Active Pools
                    </button>
                    <button
                        onClick={() => setActiveTab('my_staking')}
                        className={`px-6 py-2 rounded-full font-bold transition ${activeTab === 'my_staking' ? 'bg-purple-600 text-white' : 'bg-[#181a20] text-gray-400 hover:text-white'}`}
                    >
                        My Staking
                    </button>
                </div>

                {/* Pools Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {stakingPools.map(pool => (
                        <div key={pool.id} className="bg-[#181a20] rounded-2xl p-6 border border-gray-800 hover:border-purple-500/50 transition group">
                            <div className="flex justify-between items-start mb-6">
                                <div className="bg-gradient-to-br from-gray-700 to-gray-800 w-12 h-12 rounded-full flex items-center justify-center font-bold text-white shadow-lg">
                                    {pool.coin[0]}
                                </div>
                                <span className={`px-2 py-1 rounded text-xs font-bold uppercase ${pool.status === 'active' ? 'bg-green-500/20 text-green-400' : 'bg-gray-700 text-gray-400'}`}>
                                    {pool.status === 'full' ? 'Sold Out' : 'Active'}
                                </span>
                            </div>

                            <h3 className="text-xl font-bold text-white mb-1">{pool.coin}</h3>
                            <p className="text-gray-500 text-sm mb-6">{pool.name}</p>

                            <div className="space-y-4 mb-8">
                                <div className="flex justify-between">
                                    <span className="text-gray-400 text-sm">APR</span>
                                    <span className="text-green-400 font-bold text-lg">{pool.apr}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-400 text-sm">Duration</span>
                                    <span className="text-white font-medium">{pool.duration}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-400 text-sm">Min Stake</span>
                                    <span className="text-white font-medium">{pool.minStake}</span>
                                </div>
                            </div>

                            <button className="w-full bg-purple-600 hover:bg-purple-500 text-white py-3 rounded-xl font-bold transition">
                                Stake Now
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StakingPage;
